// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function sequence(results) {
  return Stdlib_Array.reduce(results, {
    TAG: "Ok",
    _0: []
  }, (maybeAcc, res) => Stdlib_Result.flatMap(maybeAcc, acc => Stdlib_Result.map(res, x => acc.concat([x]))));
}

function sequence2(param) {
  let rb = param[1];
  let ra = param[0];
  if (ra.TAG === "Ok") {
    if (rb.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: [
          ra._0,
          rb._0
        ]
      };
    } else {
      return {
        TAG: "Error",
        _0: rb._0
      };
    }
  } else {
    return {
      TAG: "Error",
      _0: ra._0
    };
  }
}

function sequence3(param) {
  return Stdlib_Result.map(sequence2([
    sequence2([
      param[0],
      param[1]
    ]),
    param[2]
  ]), param => {
    let match = param[0];
    return [
      match[0],
      match[1],
      param[1]
    ];
  });
}

function sequence4(param) {
  return Stdlib_Result.map(sequence2([
    sequence3([
      param[0],
      param[1],
      param[2]
    ]),
    param[3]
  ]), param => {
    let match = param[0];
    return [
      match[0],
      match[1],
      match[2],
      param[1]
    ];
  });
}

function sequence5(param) {
  return Stdlib_Result.map(sequence2([
    sequence4([
      param[0],
      param[1],
      param[2],
      param[3]
    ]),
    param[4]
  ]), param => {
    let match = param[0];
    return [
      match[0],
      match[1],
      match[2],
      match[3],
      param[1]
    ];
  });
}

function sequence6(param) {
  return Stdlib_Result.map(sequence2([
    sequence5([
      param[0],
      param[1],
      param[2],
      param[3],
      param[4]
    ]),
    param[5]
  ]), param => {
    let match = param[0];
    return [
      match[0],
      match[1],
      match[2],
      match[3],
      match[4],
      param[1]
    ];
  });
}

function sequence7(param) {
  return Stdlib_Result.map(sequence2([
    sequence6([
      param[0],
      param[1],
      param[2],
      param[3],
      param[4],
      param[5]
    ]),
    param[6]
  ]), param => {
    let match = param[0];
    return [
      match[0],
      match[1],
      match[2],
      match[3],
      match[4],
      match[5],
      param[1]
    ];
  });
}

function ok(result) {
  if (result.TAG === "Ok") {
    return Primitive_option.some(result._0);
  }
}

function traverseOption(opt, f) {
  if (opt !== undefined) {
    return Stdlib_Result.map(f(Primitive_option.valFromOption(opt)), y => Primitive_option.some(y));
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function get(x) {
  return x._0;
}

async function flatMapP(xResult, f) {
  if (xResult.TAG === "Ok") {
    return await f(xResult._0);
  } else {
    return {
      TAG: "Error",
      _0: xResult._0
    };
  }
}

async function mapP(xResult, f) {
  if (xResult.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: await f(xResult._0)
    };
  } else {
    return {
      TAG: "Error",
      _0: xResult._0
    };
  }
}

export {
  sequence,
  sequence2,
  sequence3,
  sequence4,
  sequence5,
  sequence6,
  sequence7,
  ok,
  traverseOption,
  get,
  flatMapP,
  mapP,
}
/* No side effect */
